<template>
  <div class="big">
    <div class="page_title">员工奖励</div>
    <div class="container" style="padding: 20px">
      <el-tabs v-model="activeName">
        <el-tab-pane
          label="医生活跃开单奖励"
          name="1"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('1933') : false
          "
        ></el-tab-pane>
        <!-- <el-tab-pane
          label="开单新医生奖励"
          name="2"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('1935') : false
          "
        ></el-tab-pane>
        <el-tab-pane
          label="业务所属领导奖励"
          name="3"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('1937') : false
          "
        ></el-tab-pane> -->
      </el-tabs>
      <keep-alive>
        <component :is="currentComponent" />
      </keep-alive>
    </div>
  </div>
</template>
  <script>
import activeDoctor from "./activeDoctor/index.vue";
import newDoctor from "./newDoctor/index.vue";
import recommenderLeader from "./recommenderLeader/index.vue";
export default {
  data() {
    return {
      activeName: "1",
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array || [];
    },
    currentComponent() {
      switch (this.activeName) {
        case "1":
          return activeDoctor;
        case "2":
          return newDoctor;
        case "3":
          return recommenderLeader;
        default:
          return activeDoctor;
      }
    },
  },
  created() {},
  methods: {},
};
</script>
  <style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
</style>
  